import {
  ADD_TO_CART,
  DECREASE_QUANTITY,
  DELETE_FROM_CART,
  DELETE_ALL_FROM_CART,
  GET_CART_DATA,
  INCREASE_QUANTITY
} from "../actions/cartActions";
import { AppInstance } from "../../api/instance";

const initState = [];

const cartReducer = (state = initState, action) => {
  const cartItems = state,
    product = action.payload;
  if (action.type === GET_CART_DATA) {
    return product
  }

  if (action.type === ADD_TO_CART) {
    return product
  }

  if (action.type === DECREASE_QUANTITY) {
    return cartItems.map((item) =>
      item.variant_id === product?.variant_id
        ? { ...item, quantity: item.quantity - 1 }
        : item
    );
  }

  if (action.type === INCREASE_QUANTITY) {
    AppInstance({
      method: 'delete',
      url: `/cart?variant_id=${product.variant_id}&quantity=1`,
    }).then((res) => {
      console.log(res.data.data);

      if (res?.data.data) {
        return cartItems.map(item =>
          item.variant_id === res?.data?.data?.variant_id ? res?.data?.data : item
        );
      } else {
        if (product?.quantity === 1 || res?.data?.message === "Item does not exist") {
          return cartItems.find((item) => item?.cart_id !== product?.cart_id)
        }
      }
    }).catch((error) => {
      console.log(error, "cart add fail");
    })
  }
  if (action.type === DELETE_FROM_CART) {
    AppInstance({
      method: 'delete',
      url: `/cart?variant_id=${product.variant_id}&quantity=${product.quantity}`,
    }).then((res) => {
      if (res.status === 200) {
        // getCartData();
      } else {
        console.log("somthing went wrong");
      }
    }).catch((error) => {
      console.log(error, "cart add fail");
    })
    const remainingItems = (cartItems, product) =>
      cartItems.filter(cartItem => cartItem.id !== product.id);
    return remainingItems(cartItems, product);
  }

  if (action.type === DELETE_ALL_FROM_CART) {
    return cartItems.filter(item => {
      return false;
    });
  }

  return state;
};

export default cartReducer;
